import React, { useState, useEffect, Fragment } from "react";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import axios from "axios";
import Modal from "react-bootstrap/Modal";
import toast from "react-hot-toast";
import $ from "jquery";
import moment from "moment";

import addbutton from "../static/images/add-button.png";
//import baclogo from "../static/images/educacion.png";
import educacionlogo from "../static/images/educacion_default.png";

const Educacion = ({ data, edit }) => {
  const [mesArr] = useState([]);
  const [yearArr] = useState([]);
  const [loading, setLoading] = useState(true);
  const [listEducacion, setlistEducacion] = useState("");
  const [eduUpdate, seteduUpdate] = useState("");
  const [flagUpdate, setflagUpdate] = useState(false);
  const [deleteEd, setdeleteEd] = useState();
  const [show, setShow] = useState(false);
  const [allowAction, setallowAction] = useState(false);
  const [actualEducation, setactualEducation] = useState(false);

  const handleClose = () => setShow(false);

  useEffect(() => {
    let rol = localStorage.getItem("rol");
    setallowAction(rol === "company" || rol === "institute" ? false : true);
    if (data === undefined) {
      setLoading(true);
    } else {
      fillDate();
      GetEducacion();
    }
  }, [data]);

  function fillDate() {
    for (var i = 1; i <= 12; i++) {
      let mes = { value: "", desc: "" };

      mes.value = i;
      mes.desc = i;
      mesArr.push(mes);
    }

    let currentYear = new Date().getFullYear();
    let earliestYear = 1970;

    while (currentYear >= earliestYear) {
      let year = { value: "", desc: "" };

      year.value = currentYear.toString();
      year.desc = currentYear.toString();
      yearArr.push(year);
      currentYear -= 1;
    }
  }
  function GetEducacion() {
    axios.get("education/list-education-applicant/" + data).then((result) => {
      setlistEducacion(result.data);
      setLoading(false);
    });
  }

  function GuardarEducacion(
    values,
    resetForm = () => {}
  ) {
    const startDate = new Date(values.anoInicio, values.mesInicio - 1);
    const endDate = new Date(values.anoFin, values.mesFin);

    //validar que la fecha de inicio sea mayor que la fecha de fin
    if (!actualEducation) {
      if (endDate < startDate) {
        toast.error("Las fechas son inválidas, favor verifique!", {
          duration: 5000,
        });
        return;
      }
    }

    let edu = {
      applicantEducationRestId: data,
      applicantId: data,
      nameInstitute: values.nameinstitute,
      titleName: values.titlename,
      titleNameDateEnd: endDate,
      titleNameDateInit: startDate,
      description: values.description,
      enCurso: values.currentEducation,
    };


    axios
      .post("education/create-applicant-education", edu)
      .then((result) => {
        if (result.status === 200) {
          toast.success(result.data.message, {
            duration: 4000,
          });
          GetEducacion();
          $("#agregar-eduacion-modal").modal("hide");
          setactualEducation(false);

          resetForm(true)
        }
      })
      .catch(function (error) {
        $("#agregar-eduacion-modal").modal("hide");
      });
  }

  function SearchEducacion(id) {
    seteduUpdate(listEducacion.find((item) => item.titleNameId === id));
    setflagUpdate(true);
    setactualEducation(
      listEducacion.find((item) => item.titleNameId === id).enCurso
    );
  }

  function ActualizarEducacion(values) {
    const startDate = new Date(values.anoInicio, values.mesInicio - 1);
    const endDate = new Date(values.anoFin, values.mesFin - 1);

    //validar que la fecha de inicio sea mayor que la fecha de fin
    if (!actualEducation) {
      if (endDate < startDate) {
        toast.error("Las fechas son inválidas, favor verifique!", {
          duration: 5000,
        });
        return;
      }
    }

    let edu = {
      applicantEducationRestId: eduUpdate.titleNameId,
      applicantId: data,
      description: values.description,
      nameInstitute: values.nameinstitute,
      titleName: values.titlename,
      titleNameDateEnd: endDate,
      titleNameDateInit: startDate,
      enCurso: values.currentEducation,
    };

    axios
      .post("education/update-educationapplicant",edu)
      .then((result) => {
        if (result.status === 200) {
          toast.success(result.data.message, {
            duration: 4000,
          });
          setflagUpdate(false);
          GetEducacion();
          $("#actualizar-eduacion-modal").modal("hide");
        }
      })
      .catch(function (error) {
        $("#actualizar-eduacion-modal").modal("hide");
      });
  }

  const Validaciones = Yup.object().shape({
    nameinstitute: Yup.string()
      .required("No puede estar vacio")
      .max(60, "No puede tener mas de 60 caracteres"),
    description: Yup.string()
      .required("No puede estar vacio")
      .max(250, "No puede tener mas de 250 caracteres"),
    titlename: Yup.string()
      .required("No puede estar vacio")
      .max(60, "No puede tener mas de 60 caracteres"),
    mesInicio: Yup.number()
      .required("No puede estar vacio")
      .integer("Tiene que ser un numero entero"),
    anoInicio: Yup.number()
      .required("No puede estar vacio")
      .integer("Tiene que ser un numero entero"),
    mesFin: Yup.number()
      .required("No puede estar vacio")
      .integer("Tiene que ser un numero entero"),
    anoFin: Yup.number()
      .required("No puede estar vacio")
      .integer("Tiene que ser un numero entero"),
  });

  function modalDelete(id) {
    setdeleteEd(id);
    setShow(true);
  }

  function DeleteEducacion() {
    const exp = {
      applicantEducationRestId: deleteEd,
      applicantId: data,
      description: "string",
      nameInstitute: "string",
      titleName: "string",
      titleNameDateEnd: "2021-03-26T21:35:05.033Z",
      titleNameDateInit: "2021-03-26T21:35:05.033Z",
    };

    axios
      .post("education/delete-applicanteducation", exp)
      .then((result) => {
        if (result.status === 200) {
          setShow(false);
          toast.success(result.data.message, {
            duration: 4000,
          });
          GetEducacion();
          setactualEducation(false);
          $("#actualizar-eduacion-modal").modal("hide");
        }
      })
      .catch(function (error) {
        $("#actualizar-eduacion-modal").modal("hide");
      });
  }

  function inHabilitarFechaFin() {
    setactualEducation(!actualEducation);
  }

  return (
    <Fragment>
      {loading ? (
        <label className="login-label">CARGANDO</label>
      ) : (
        <Fragment>
          <div className="box left-col">
            <div className="head">
              <div className="title">Educación</div>
              {edit ? (
                <a
                  href="#"
                  data-bs-toggle="modal"
                  data-bs-target="#agregar-eduacion-modal"
                >
                  <img src={addbutton} alt="Agregar Experiencia"></img>
                </a>
              ) : (
                ""
              )}
            </div>
            {listEducacion.map((item, index) => {
              return (
                <div key={index} className="company">
                  <div className="company__wrapper">
                    <div className="logo">
                      <img src={educacionlogo} alt={"logo-empresa" + index}></img>
                    </div>
                    <div className="content">
                      <div className="asistente">{item.titleName}</div>
                      <div className="name">{item.nameInstitute}</div>
                      <div className="date">
                        {moment(item.educdateInit, "YYYY-MM-DD").format("MMMM-YYYY")
                          + " / " +

                          (item.enCurso
                            ? "Actualmente"
                            : moment(item.educdateEnd, "YYYY-MM-DD").format("MMMM-YYYY") 
                          )
                        }
                        <span></span>
                      </div>
                    </div>
                  </div>
                  <div id="job-description-1" className="collapse company__bio">
                    {item.description}
                  </div>
                  <div className="toolset">
                    {edit &&
                      <button
                        className="edit-button"
                        data-bs-toggle="modal"
                        data-bs-target="#actualizar-eduacion-modal"
                        onClick={() => SearchEducacion(item.titleNameId)}
                      > </button>
                    }
                    <button
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#job-description-1"
                      aria-expanded="false"
                      aria-controls="job-description-1"
                      className="view-more"
                    >
                      Ver Más <i className="fas fa-chevron-down"></i>
                    </button>
                  </div>
                </div>
              );
            })}
          </div>

          <div
            id="agregar-eduacion-modal"
            className="kr-modal modal fade"
            tabIndex="-1"
            role="dialog"
            aria-hidden="true"
          >
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <div className="modal-title"></div>

                  <button
                    type="button"
                    className="close"
                    data-bs-dismiss="modal"
                    aria-label="close"
                    onClick={() => setactualEducation(false)}
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>

                <div className="modal-body">
                  <div className="form form--white">
                    <Formik
                      initialValues={{
                        nameinstitute: "",
                        titlename: "",
                        titlenameDateEnd: "2010-03-09T19:38:05.154Z",
                        titlenameDateInit: "2021-03-09T19:38:05.154Z",
                        mesInicio: 1,
                        anoInicio: 2021,
                        mesFin: 1,
                        anoFin: 2021,
                        description: "",
                        currentEducation: false,
                        actualEducation: false,
                      }}
                      onSubmit={(values, { setSubmitting, resetForm }) => {
                        setSubmitting(true);
                        GuardarEducacion(values, resetForm);
                        setSubmitting(false);
                      }}
                      validationSchema={Validaciones}
                    >
                      {({ errors, touched, isSubmitting }) => (
                        <Form>
                          <div className="div__wrapper">
                            <div className="form__title text-center">
                              Educación
                            </div>
                            <div className="form__description text-center">
                              Formulario para Guardar Educación
                            </div>
                            <div className="form__row">
                              <div className="col-sm-12">
                                <label htmlFor="nameinstitute">
                                  Centro de Educación
                                </label>
                                <Field
                                  id="nameinstitute"
                                  name="nameinstitute"
                                  type="text"
                                  required
                                ></Field>
                                {errors.nameinstitute &&
                                  touched.nameinstitute && (
                                    <span className="form__validation form__validation--error">
                                      {errors.nameinstitute}
                                    </span>
                                  )}
                              </div>
                              <div className="col-sm-12">
                                <label htmlFor="titlename">Titulo</label>
                                <Field
                                  id="titlename"
                                  name="titlename"
                                  type="text"
                                  required
                                ></Field>
                                {errors.titlename && touched.titlename && (
                                  <span className="form__validation form__validation--error">
                                    {errors.titlename}
                                  </span>
                                )}
                              </div>
                            </div>
                            <div className="form__row">
                              <div className="col-sm-12">
                                <label htmlFor="mesInicio">Fecha Inicio</label>
                                <Field
                                  as="select"
                                  name="mesInicio"
                                  id="mesInicio"
                                  required
                                  placeholder="Mes"
                                >
                                  {mesArr.map((item, index) => {
                                    return (
                                      <option key={index} value={item.value}>
                                        {months[item.desc]}
                                      </option>
                                    );
                                  })}
                                </Field>
                                {errors.mesInicio && touched.mesInicio && (
                                  <span className="form__validation form__validation--error">
                                    {errors.mesInicio}
                                  </span>
                                )}
                                <Field
                                  as="select"
                                  name="anoInicio"
                                  id="anoInicio"
                                  required
                                  placeholder="Año"
                                >
                                  {yearArr.map((item, index) => {
                                    return (
                                      <option key={index} value={item.value}>
                                        {item.desc}
                                      </option>
                                    );
                                  })}
                                </Field>
                                {errors.anoInicio && touched.anoInicio && (
                                  <span className="form__validation form__validation--error">
                                    {errors.anoInicio}
                                  </span>
                                )}
                              </div>
                            </div>
                            <div className="mb-4 row">
                              <div className="col-sm-1">
                                <Field
                                  type="checkbox"
                                  name="currentEducation"
                                  id="currentEducation"
                                  checked={actualEducation}
                                  onClick={inHabilitarFechaFin}
                                ></Field>
                              </div>
                              <div className="col-sm-11">
                                <label
                                  className="form-check-label"
                                  htmlFor="education-status"
                                >
                                  Actualmente en preparación
                                </label>
                              </div>
                            </div>
                            <div className="form__row">
                              <div className="col-sm-12">
                                <label htmlFor="mesFin">Fecha Fin</label>
                                <Field
                                  disabled={actualEducation}
                                  as="select"
                                  name="mesFin"
                                  id="mesFin"
                                  placeholder="Mes"
                                  className="form-select form-select-sm"
                                  required
                                >
                                  {" "}
                                  {mesArr.map((item, index) => {
                                    return (
                                      <option key={index} value={item.value}>
                                        {months[item.desc]}
                                      </option>
                                    );
                                  })}
                                </Field>
                                {errors.mesFin && touched.mesFin && (
                                  <span className="form__validation form__validation--error">
                                    {errors.mesFin}
                                  </span>
                                )}
                                <Field
                                  disabled={actualEducation}
                                  as="select"
                                  name="anoFin"
                                  id="anoFin"
                                  placeholder="Año"
                                  className="form-select form-select-sm"
                                  required
                                >
                                  {yearArr.map((item, index) => {
                                    return (
                                      <option key={index} value={item.value}>
                                        {item.desc}
                                      </option>
                                    );
                                  })}
                                </Field>
                                {errors.anoFin && touched.anoFin && (
                                  <span className="form__validation form__validation--error">
                                    {errors.anoFin}
                                  </span>
                                )}
                              </div>
                            </div>
                            <div className="col-sm-12">
                              <label htmlFor="description">Descripción</label>
                              <Field
                                as="textarea"
                                id="description"
                                name="description"
                                required
                              ></Field>
                              {errors.description && touched.description && (
                                <span className="form__validation form__validation--error">
                                  {errors.description}
                                </span>
                              )}
                            </div>
                            <div className="form__row">
                              <button
                                disabled={isSubmitting}
                                type="submit"
                                className="btn btn--gradient btn__icon btn__icon--door"
                              >
                                <i className="fas fa-paper-plane"></i>Aceptar
                              </button>
                            </div>
                          </div>
                        </Form>
                      )}
                    </Formik>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            id="actualizar-eduacion-modal"
            className="kr-modal modal fade"
            tabIndex="-1"
            role="dialog"
            aria-hidden="true"
          >
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <div className="modal-title"></div>

                  <button
                    type="button"
                    className="close"
                    data-bs-dismiss="modal"
                    aria-label="close"
                    onClick={() => setactualEducation(false)}
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>

                <div className="modal-body">
                  <div className="form form--white">
                    <Formik
                      enableReinitialize={true}
                      initialValues={{
                        nameinstitute: eduUpdate?.nameInstitute ?? "",
                        titlename: eduUpdate?.titleName ?? "",
                        titlenameDateEnd: "2010-03-09T19:38:05.154Z",
                        titlenameDateInit: "2021-03-09T19:38:05.154Z",
                        mesInicio: eduUpdate
                          ? parseInt(eduUpdate.educdateInit.substring(5, 7))
                          : 1,
                        anoInicio: eduUpdate
                          ? eduUpdate.educdateInit.substring(0, 4)
                          : 2021,
                        mesFin: eduUpdate
                          ? parseInt(eduUpdate.educdateEnd.substring(5, 7))
                          : 1,
                        anoFin: eduUpdate
                          ? eduUpdate.educdateEnd.substring(0, 4)
                          : 2021,
                        description: eduUpdate?.description,
                        currentEducation: eduUpdate?.enCurso ?? false,
                        actualEducation: eduUpdate?.enCurso?? false,
                      }}
                      onSubmit={(values, { setSubmitting, resetForm }) => {
                        setSubmitting(true);
                        ActualizarEducacion(values);
                        resetForm(true);
                        setSubmitting(false);
                      }}
                      validationSchema={Validaciones}
                    >
                      {({ errors, touched, isSubmitting }) => (
                        <Form>
                          <div className="div__wrapper">
                            <div className="form__title text-center">
                              Educacion
                            </div>
                            <div className="form__description text-center">
                              Actualizar Registro
                            </div>
                            <div className="form__row">
                              <div className="col-sm-12">
                                <label htmlFor="nameinstitute">
                                  Centro de Educación
                                </label>
                                <Field
                                  id="nameinstitute"
                                  name="nameinstitute"
                                  type="text"
                                  required
                                ></Field>
                                {errors.nameinstitute &&
                                  touched.nameinstitute && (
                                    <span className="form__validation form__validation--error">
                                      {errors.nameinstitute}
                                    </span>
                                  )}
                              </div>
                              <div className="col-sm-12">
                                <label htmlFor="titlename">Titulo</label>
                                <Field
                                  id="titlename"
                                  name="titlename"
                                  type="text"
                                  required
                                ></Field>
                                {errors.titlename && touched.titlename && (
                                  <span className="form__validation form__validation--error">
                                    {errors.titlename}
                                  </span>
                                )}
                              </div>
                            </div>
                            <div className="form__row">
                              <div className="col-sm-12">
                                <label htmlFor="mesInicio">Fecha Inicio</label>
                                <Field
                                  as="select"
                                  name="mesInicio"
                                  id="mesInicio"
                                  required
                                  placeholder="Mes"
                                >
                                  {mesArr.map((item, index) => {
                                    return (
                                      <option key={index} value={item.value}>
                                        {months[item.desc]}
                                      </option>
                                    );
                                  })}
                                </Field>
                                {errors.mesInicio && touched.mesInicio && (
                                  <span className="form__validation form__validation--error">
                                    {errors.mesInicio}
                                  </span>
                                )}
                                <Field
                                  as="select"
                                  name="anoInicio"
                                  id="anoInicio"
                                  required
                                  placeholder="Año"
                                >
                                  {yearArr.map((item, index) => {
                                    return (
                                      <option key={index} value={item.value}>
                                        {item.desc}
                                      </option>
                                    );
                                  })}
                                </Field>
                                {errors.anoInicio && touched.anoInicio && (
                                  <span className="form__validation form__validation--error">
                                    {errors.anoInicio}
                                  </span>
                                )}
                              </div>
                            </div>
                            <div className="mb-4 row">
                              <div className="col-sm-1">
                                <Field
                                  type="checkbox"
                                  name="currentEducation"
                                  id="currentEducation"
                                  checked={actualEducation}
                                  onClick={inHabilitarFechaFin}
                                ></Field>
                              </div>
                              <div className="col-sm-11">
                                <label
                                  className="form-check-label"
                                  htmlFor="education-status"
                                >
                                  Actualmente en preparación
                                </label>
                              </div>
                            </div>
                            <div className="form__row">
                              <div className="col-sm-12">
                                <label htmlFor="mesInicio">Fecha Fin</label>
                                <Field
                                  disabled={actualEducation}
                                  as="select"
                                  name="mesFin"
                                  id="mesFin"
                                  placeholder="Mes"
                                  className="form-select form-select-sm"
                                  required
                                >
                                  {" "}
                                  {mesArr.map((item, index) => {
                                    return (
                                      <option key={index} value={item.value}>
                                        {months[item.desc]}
                                      </option>
                                    );
                                  })}
                                </Field>
                                {errors.mesFin && touched.mesFin && (
                                  <span className="form__validation form__validation--error">
                                    {errors.mesFin}
                                  </span>
                                )}
                                <Field
                                  disabled={actualEducation}
                                  as="select"
                                  name="anoFin"
                                  id="anoFin"
                                  placeholder="Año"
                                  className="form-select form-select-sm"
                                  required
                                >
                                  {yearArr.map((item, index) => {
                                    return (
                                      <option key={index} value={item.value}>
                                        {item.desc}
                                      </option>
                                    );
                                  })}
                                </Field>
                                {errors.anoFin && touched.anoFin && (
                                  <span className="form__validation form__validation--error">
                                    {errors.anoFin}
                                  </span>
                                )}
                              </div>
                            </div>
                            <div className="col-sm-12">
                              <label htmlFor="description">Descripción</label>
                              <Field
                                as="textarea"
                                id="description"
                                name="description"
                                required
                              ></Field>
                              {errors.description && touched.description && (
                                <span className="form__validation form__validation--error">
                                  {errors.description}
                                </span>
                              )}
                            </div>
                            <div className="form__row">
                              <button
                                disabled={isSubmitting}
                                type="submit"
                                className="btn btn--gradient btn__icon btn__icon--door"
                              >
                                <i className="fas fa-paper-plane"></i>Aceptar
                              </button>
                              <button
                                type="button"
                                className="btn btn-danger"
                                onClick={() =>
                                  modalDelete(eduUpdate.titleNameId)
                                }
                              >
                                Eliminar
                              </button>
                            </div>
                          </div>
                        </Form>
                      )}
                    </Formik>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <Modal
            show={show}
            keyboard={false}
            onHide={handleClose}
            dialogClassName="kr-modal"
          >
            <Modal.Body>
              <div className="form form--white ">
                <div className="div__wrapper">
                  <div className="form__title text-center">
                    Eliminar Educacion
                  </div>
                  <div className="form__row">
                    <div className="col-sm-12 ">
                      <label htmlFor="names">
                        Desea eliminar este registro?
                      </label>
                    </div>
                  </div>
                  <div className="form__row">
                    <button
                      className="btn btn--gradient btn__icon btn__icon--door"
                      onClick={() => DeleteEducacion()}
                    >
                      Eliminar
                    </button>
                  </div>
                </div>
              </div>
            </Modal.Body>
          </Modal>
        </Fragment>
      )}
    </Fragment>
  );
};

var months = {
  1: "Enero",
  2: "Febrero",
  3: "Marzo",
  4: "Abril",
  5: "Mayo",
  6: "Junio",
  7: "Julio",
  8: "Agosto",
  9: "Septiembre",
  10: "Octubre",
  11: "Noviembre",
  12: "Diciembre",
};

export default Educacion;
